<template>
    <div class="box">
        <div class="content-container">
            <div class="left-content-box" v-infinite-scroll="load">
                <no-data v-if="tableData.length == 0"></no-data>
                <div v-for="(item, index) in tableData" class="left-item"
                    :class="{ 'active-item': item.id == currentId }" @click="changeTask(item)" :key="index">
                    <div class="task-top">
                        <el-tooltip effect="dark" :disabled="item.examineName.length>11?false:true" :content="item.examineName" placement="top-start">
                            <p class="task-name overflow">{{ item.examineName }}</p>
                        </el-tooltip>
                        <div class="label-status"
                            :style="`background-color:${filterTaskStatus(item.examineStatus).color};`">{{
                                filterTaskStatus(item.examineStatus).label }}</div>
                    </div>
                    <div class="item" style="margin-top: 1rem;">
                        <p>开始时间：</p>
                        <p>{{ item.beginTime }}</p>
                    </div>
                    <div class="item" style="margin-top: 1rem;">
                        <p>结束时间：</p>
                        <p>{{ item.endTime }}</p>
                    </div>
                    <div style="display: flex;justify-content: space-between;margin-top: 1rem;">
                        <div class="item">
                            <p>总分：</p>
                            <p class="overflow">{{ item.fullScore }}</p>
                        </div>
                        <div class="item">
                            <p>及格分：</p>
                            <p>{{ item.passScore }}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="right-content-box">
                <Table :totalSize="listData.length" style="width: 100%;" :pagination="false" :operationWidth="350"
                    :currentPage="listPages.current" :pageSize="listPages.size" navHeight=40 ref="table" :tableData="listData"
                    :tableKey="tableKey">
                    <template slot="operation" slot-scope="data">
                        <div class="btn-button disable-button"
                            v-if="['0', '2', '3'].includes(data.data.row.examineStatus) && isTimeArea(data.data.row.beginTime, data.data.row.endTime)">
                            开始任务</div>
                        <div class="btn-button"
                            v-else-if="['1', null].includes(data.data.row.examineStatus) && isTimeArea(data.data.row.beginTime, data.data.row.endTime)"
                            @click="startTask(data.data.row)">开始任务</div>
                        <div class="btn-button" v-else-if="!isTimeArea(data.data.row.beginTime, data.data.row.endTime)"
                            @click="viewScoreDetail(data.data.row)">查看详情</div>
                    </template>
                    <template slot="type" slot-scope="data">
                        <p>{{ data.data.row.type == '0' ? '理论考核' : '虚仿考核' }}</p>
                    </template>
                </Table>
            </div>
        </div>
        <examine-score-detail ref="examine_score_detail"></examine-score-detail>
        <theory-detail :detail="detail" ref="theory_detail"></theory-detail>
    </div>
</template>

<script>
import { PageExamineStd, QueryExamineDetailById, GetSoftwareScoreTree, PushExamineRecord } from '@/api/examine';
import { GetUserAnswerRecord, GetTestPaperQuestion } from '@/api/paper';
import StartTask from './StartTask.vue';
import { isTimeArea } from '@/utils/utils';
import { filterTaskStatus } from '@/utils/utils';
import ExamineTree from '../../backendSys/examineMag/virtual/ExamineTree.vue';
import ChooseSoftware from './ChooseSoftware.vue';
import TheoryDetail from './TheoryDetail.vue';
import AllStartTask from './AllStartTask.vue';
import ExamineScoreDetail from './ExamineScoreDetail.vue';
export default {
    components: { StartTask, ExamineTree, ChooseSoftware, TheoryDetail, AllStartTask, ExamineScoreDetail },
    props: ['name', 'examineStatus'],
    data() {
        return {
            pages: {
                current: 1,
                size: 99,
                total: 0
            },
            listPages:{
                current: 1,
                size: 10,
            },
            tableData: [],
            listData: [],
            currentId: '',
            tableKey: [
                {
                    name: '名称',
                    value: 'name',
                },
                {
                    name: '考核类型',
                    value: 'type',
                    slot: 'type'
                },
                {
                    name: '软件类型',
                    value: 'resType',
                },
                {
                    name: '',
                    value: 'operation',
                    slot: 'operation'
                },
            ],
            detail: {},
            recordId: '',
        }
    },
    methods: {
        isTimeArea(start, end) {
            return isTimeArea(start, end);
        },
        load() {
            let total = this.pages.current * this.pages.size;
            if (total >= this.pages.total) return;
            this.pages.current++;
            this.pageExamineStd();
        },
        filterTaskStatus,
        startTask(item) {
            if (item.examineStatus == '2') {
                return;
            }
            if (item.type == '0') {
                var href = window.location.origin + `/theoryTest?id=${item.id}&examineId=${this.currentId}`;
                window.open(href, '_blank');
            } else {
                if (item.resType == '单机') {
                    if (!item.regedit) {
                        this.$msg({
                            showClose: true,
                            message: "暂无资源",
                            type: "warning",
                        });
                        return;
                    }
                    detectProtocol(item.regedit + '://', () => {
                        console.log("未找到协议.");
                        this.$confirm("未检测到软件，立即下载。", "提示", {
                            confirmButtonText: "确定",
                            cancelButtonText: "取消",
                            type: "warning"
                        })
                            .then(() => {
                                if (item.fileId) {
                                    getFileInfo(item.fileId).then(res => {
                                        if (res.code == 200) {
                                            var src = this.$severUrl(res.data.fileUrl);
                                            var link = document.createElement('a');
                                            link.href = src;
                                            document.body.appendChild(link);
                                            link.click();
                                            document.body.removeChild(link);
                                        }
                                    })
                                } else {
                                    this.$msg({
                                        showClose: true,
                                        message: "暂无资源",
                                        type: "warning",
                                    });
                                }
                            })
                            .catch(() => {
                                this.$message({
                                    type: "info",
                                    message: "已取消下载"
                                });
                            });
                    },
                        () => {
                            console.log("找到自定义协议并成功打开文件.");
                        },
                        1000
                    );
                } else {
                    let params = {
                        "examineId": this.currentId,
                        "examineType": '2',
                        "resourceId": item.id,
                        "type": 0
                    };
                    PushExamineRecord(params).then(res => {
                        if (res.code == 200) {
                            sessionStorage.setItem('businessId', this.currentId + '-' + item.id);
                            let href = window.location.origin + `/virtualTest?url=${item.url}&optSource=sp_examine&businessId=${this.currentId + '-' + item.id}`;
                            window.open(href, '_blank');
                        }
                    })
                }
            }
        },
        /**查看得分详情 */
        viewScoreDetail(data) {
            if (data.type == '1') {
                let params = {
                    examineId: this.currentId,
                    softwareId: data.id,
                    userId: this.$store.state.user.userInfo.id
                }
                GetSoftwareScoreTree(params).then(res => {
                    let dialog = this.$refs.examine_score_detail;
                    if (dialog) {
                        dialog.dialogVisible = true;
                        dialog.detail = res.data;

                    }
                });
            } else {
                this.getUserAnswerRecord(data.id);
            }
        },
        /**获取用户答题记录 */
        getUserAnswerRecord(paperId) {
            return new Promise(resolve => {
                var params = {
                    "businessId": this.currentId + '-' + paperId,
                    "testPaperId": paperId,
                    "testPaperSource": 'examine_paper'
                }
                GetUserAnswerRecord(params).then(async (res) => {
                    if (res.code == 200) {
                        this.recordId = res.data.id;
                        await this.getTestPaperQuestion(paperId);
                        this.$set(this.detail, 'userQuestionScoreVOS', res.data.userQuestionScoreVOS);
                        let startTime = new Date(res.data.startTime).getTime();
                        let endTime = new Date(res.data.endTime).getTime();
                        let userTestTime = (endTime - startTime) / 1000;
                        this.$set(this.detail, 'userTestTime', userTestTime);
                        let questionDetailVOS = this.detail.questionDetailVOS;
                        res.data.userQuestionScoreVOS && res.data.userQuestionScoreVOS.forEach(item => {
                            var data = questionDetailVOS[item.questionType];
                            var userAnswer = item.userAnswer || [];
                            if (data) {
                                let e = data.find(el => el.questionId == item.questionId);
                                if (e) {
                                    this.$set(e, 'correctAnswer', item.correctAnswer || []);
                                    this.$set(e, 'score', item.score || 0);
                                    this.$set(e, 'content', item.content || '暂无');
                                    var questionType = item.questionType;
                                    if (questionType == '多选题') {
                                        e.value = userAnswer;
                                    } else if (questionType == '填空题') {
                                        e.questionOptionVOS.forEach((a, b) => {
                                            a.value = userAnswer[b] ? userAnswer[b] : '';
                                        })
                                    } else {
                                        e.value = userAnswer[0] ? userAnswer[0] : '';
                                    }
                                }
                            }
                        })
                        resolve(res.data);
                    }
                })
            })
        },
        /**获取试卷题目数据 */
        getTestPaperQuestion(paperId) {
            return new Promise(resolve => {
                var params = {
                    "businessId": this.currentId + '-' + paperId,
                    "testPaperId": paperId,
                    "testPaperRecordId": this.recordId
                }
                GetTestPaperQuestion(params).then(res => {
                    if (res.code == 200) {
                        var questionDetailVOS = res.data.questionDetailVOS;
                        var i = 1;
                        for (let key in questionDetailVOS) {
                            questionDetailVOS[key].orderIndex = i;
                            i++;
                            questionDetailVOS[key] && questionDetailVOS[key].forEach(item => {
                                if (key == '多选题') {
                                    item.value = [];
                                    return;
                                } else if (key == '填空题') {
                                    item.questionOptionVOS && item.questionOptionVOS.forEach(el => {
                                        el.value = '';
                                    })
                                } else {
                                    item.value = '';
                                }
                            })
                        }
                        this.detail = res.data;
                        let dialog = this.$refs.theory_detail;
                        if (dialog) {
                            dialog.dialogVisible = true;
                        }
                        resolve(res.data);
                    }
                })
            })
        },
        pageExamineStd() {
            let params = {
                "current": this.pages.current,
                "examineName": this.name,
                "examineStatus": this.examineStatus,
                "examineType": '2',
                "size": this.pages.size
            };
            PageExamineStd(params).then(res => {
                if (res.code == 200) {
                    if (this.pages.current == 1) {
                        this.tableData = res.data.records;
                        if(this.tableData.length > 0){
                            this.currentId = this.tableData[0].id;
                            this.changeTask(this.tableData[0]);
                        }else{
                            this.currentId='';
                            this.listData=[];
                        }
                    } else {
                        this.tableData = [...this.tableData, ...res.data.records];
                    }
                    this.pages.total = res.data.total;
                }
            })
        },
        /**模糊查询 */
        search() {
            this.pages.current = 1;
            this.pageExamineStd();
        },
        /**切换任务 */
        changeTask(data) {
            this.currentId = data.id;
            QueryExamineDetailById({ id: data.id }).then(res => {
                if (res.code == 200) {
                    let arr1 = res.data.softwareDetailList.map(item => {
                        return {
                            type: '1',
                            id: item.id,
                            name: item.softwareName,
                            softwareCode: item.softwareCode,
                            examineStatus: item.examineStatus,
                            beginTime: data.beginTime,
                            endTime: data.endTime,
                            url: item.url,
                            resType: item.resType
                        }
                    });
                    let arr2 = res.data.paperDetailList.map(item => {
                        return {
                            type: '0',
                            id: item.id,
                            name: item.testPaperName,
                            examineStatus: item.examineStatus,
                            beginTime: data.beginTime,
                            endTime: data.endTime,
                        }
                    })
                    this.listData = [...arr1, ...arr2];
                }
            })
        },
    },
    mounted() {
        this.search();
    },
    watch: {
        examineStatus() {
            this.search();
        },
    }
}
</script>

<style lang="less" scoped>
.box {
    height: 100%;
}

.btn-button {
    width: 70px;
    height: 25px;
    color: #ffffff;
    background-color: var(--blue);
    border-radius: 0.6rem;
    display: flex;
    font-size: 14px;
    justify-content: center;
    align-items: center;
    cursor: pointer;
}

/deep/th {
    background-color: #ffffff !important;
}

.disable-button {
    cursor: not-allowed !important;
    background-color: #C0C4CC !important;
}

.no-test {
    color: red;
}

.content-container {
    height: calc(100% - 2rem);
    display: flex;
}

.table-item {
    border-bottom: 1px solid #e0e8f2;
    padding: 2.4rem 3.7rem 2.2rem 6.5rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.task-name {
    font-weight: 700;
    font-size: 16px;
}

.label-status {
    padding: 0.2rem 0.5rem;
    min-width: 4.7rem;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 0.4rem 0px 0.4rem 0px;
    color: #ffffff;
}

.top-content {
    display: flex;
}

.bottom-content {
    margin-top: 12px;
    display: flex;
    font-size: 14px;
    color: #8590B3;

    &> :nth-child(n) {
        margin-left: 4.5rem;
    }

    &> :nth-child(1) {
        margin-left: 0;
    }
}

.item {
    display: flex;
}

.page-box {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 2rem;
}

.detail-img {
    width: 2.1rem;
    margin-left: 1rem;
    cursor: pointer;
}

.left-content-box {
    width: 30rem;
    height: 100%;
    overflow: auto;
    background-color: #ffffff;

    .left-item {
        padding: 2rem;
        border-bottom: 1px solid #e0e8f2;
        cursor: pointer;

        .task-name {
            font-weight: 700;
            font-size: 16px;
        }
    }
}

.active-item {
    background-color: var(--blue) !important;
    color: #ffffff !important;
}

.right-content-box {
    width: calc(100% - 32rem);
    height: 100%;
    margin-left: 2rem;
    display: flex;
    align-items: flex-start;
    flex-wrap: wrap;
    overflow: auto;
}
.task-top{
    display: flex;
    justify-content: space-between;
    align-items: center;
    &> :nth-child(1){
        flex: 1;
    }
    &> :nth-child(2){
        margin-left: 1rem;
    }
}
/deep/.table {
    height: 100%;
}
@media screen and (max-width:750px){
    .content-container{
        flex-direction: column;
    }
    .left-content-box{
        height: auto;
        width: 100%;
        display: flex;
    }
    .right-content-box{
        margin-left: 0 !important;
        margin-top: 2rem;
        width: 100%;
        flex: 1;
    }
}
</style>